"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Request = void 0;
const axios_1 = __importDefault(require("axios"));
exports.Request = {
    /**
     * HTTP 请求方法
     * @param url 请求链接
     * @param method HTTP 请求方法 (如 GET, POST 等)
     * @param params 请求参数
     * @param headers 请求头
     * @param timeout 超时时间（毫秒）
     * @returns 返回包含状态和数据的 Promise 对象
     */
    ajax(url, method, params, headers, timeout) {
        const config = {
            url: url,
            method: method,
        };
        if (params) {
            config.data = params;
        }
        if (headers) {
            config.headers = headers;
        }
        axios_1.default.defaults.timeout = timeout ? timeout : 10000;
        return new Promise(resolve => {
            (0, axios_1.default)(config)
                .then(response => {
                if (response.status === 200) {
                    resolve({
                        status: 'success',
                        data: response.data,
                    });
                }
                else {
                    resolve({
                        status: 'error',
                        data: response.data?.message || '未知错误',
                    });
                }
            })
                .catch(error => {
                resolve({
                    status: 'error',
                    data: error.message,
                });
            });
        });
    },
};
exports.default = exports.Request;
